import { useContext } from 'react';
import { AgentContext } from '../contexts/AgentContext';

export const useAgent = () => {
    const { agent } = useContext(AgentContext) || {};
    return agent;
};